<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue';
import { YMap, YMapControls, YMapControl, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } from './lib/ymaps';
import type { YMapLocationRequest } from 'ymaps3';

import { MapComponent } from './view/mapcomponent/mapcomponent';
import { PointsList } from './view/pointslist/pointslist';
import { InputsPanel } from './view/inputspanel';
import { ButtonsPanel } from './view/buttonspanel/buttonspanel';
import { StorageSelector } from './view/storageselector/storageselector';
//import { DriverSelector } from "./view/driverselector/driverselector";
import { InfoPanel } from "./view/infopanel/infopanel";
import { mapState, mapActions, mapGetters } from "pinia";
import { useRoutingStore } from './store';
import { RoadOptions } from "./view/roadoptions/roadoptions";

import { useWebSocketStore } from './stores/websocket';

import './view/index.css';

const websocketStore = useWebSocketStore();

let parentGuid;
let myGuid;

let mapDataRecieved = false;

// Функция для получения координат через Яндекс Maps API
async function getCoordinates(addressObj) {

  const apiKey = '01af1e5c-54ea-48a8-97ba-04e2d423c132'; //9bce4b59-6e44-4849-89c6-35b796509df2
  const url = `https://geocode-maps.yandex.ru/1.x/?format=json&apikey=${apiKey}&geocode=${encodeURIComponent(addressObj.address)}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.response.GeoObjectCollection.metaDataProperty.GeocoderResponseMetaData.found > 0) {
      const pos = data.response.GeoObjectCollection.featureMember[0]
        .GeoObject.Point.pos.split(' ');

      // Формат: [longitude, latitude]
      return {
        ...addressObj, // сохраняем исходные данные
        coordinates: [
          parseFloat(pos[0]), // longitude
          parseFloat(pos[1])  // latitude
        ],
        geocoded: true,
        error: null
      };
    } else {
      console.warn(`Адрес не найден: ${addressObj.address}`);
      alert(`Адрес не найден: ${addressObj.address}`);
      return {
        ...addressObj,
        coordinates: null,
        geocoded: false,
        error: "Адрес не найден"
      };
    }
  } catch (error) {
    console.error(`Ошибка при запросе для адреса ${addressObj.address}:`, error);
    return {
      ...addressObj,
      coordinates: null,
      geocoded: false,
      error: error.message
    };
  }
}

// Основная функция для обработки всех адресов
async function geocodeAllAddresses(addressesArray) {
  const results = [];

  // Обрабатываем адреса последовательно с задержкой
  for (let i = 0; i < addressesArray.length; i++) {
    const addressObj = addressesArray[i];

    if (!addressObj.hasOwnProperty('coordinates')) {
      //console.log(`Обрабатывается адрес ${i + 1}/${addressesArray.length}: ${addressObj.name}`);
      const result = await getCoordinates(addressObj);
      //results.push(result);
      if (result.geocoded) {
        results.push(result);
      }

      // Задержка между запросами (250мс чтобы не превысить лимиты API)
      await new Promise(resolve => setTimeout(resolve, 250));
    } else {
      //console.log(`Координаты есть ${i + 1}/${addressesArray.length}: ${addressObj.name}`);
      results.push(addressObj);
    }

  }

  return results;
}

function getQueryParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (e) { return null; }
}

const handleRouteData = (routeData) => {
  //console.log('Данные маршрута:', routeData);
  const message = {
      messageType: 'routeData',
      routeData: routeData
  };

  websocketStore.send(parentGuid, message);

  // Для верности отправим еще пару раз, бывало что с первого раза не доходило, не будем мудрить с подтверждением получения через вебсокет, возможно такой вариант подойдет.
  let count = 0;
  const intervalId = setInterval(() => {
      console.log(`Отправка №${count + 1}: ${new Date().toLocaleTimeString()}`);
      websocketStore.send(parentGuid, message);
      count++;
      if (count >= 2) {
          clearInterval(intervalId);
      }
  }, 1000);
};

onMounted(async () => {

  const routingStore = useRoutingStore();

  myGuid = getQueryParam("childGuid");
  parentGuid = getQueryParam("parentGuid");

  // console.log(`myGuid: ${myGuid}`);
  // console.log(`parentGuid: ${parentGuid}`);

  const host = window.location.hostname;

  websocketStore.connect(`wss://${host}/ws`, myGuid, parentGuid) // maps.ivn1.ru

  // Следим за изменениями последнего сообщения
  watch(() => websocketStore.lastMessage, (newMessage) => {
    if (newMessage) {

      //console.log('New WebSocket message in App.vue:', newMessage)

      const data = newMessage;

      switch(data.type) {
        case 'message':
          //console.log(`Сообщение получено от клиента: ${data.fromGuid}`);
          if (data.content.messageType === 'mapData' && !mapDataRecieved) {

            mapDataRecieved = true;

            const startPoint = data.content.data.startPoint;
            const points = data.content.data.points;

            window.mapComponent.setLocation(startPoint.coordinates, 11);

            //const addresses = [];
            let addresses = points;

            addresses = addresses.map((item, index) => ({
              ...item,
              title: item.name,
              price: 0
            }));

            geocodeAllAddresses(addresses)
              .then(geocodedAddresses => {
                console.log("Все адреса с координатами:", geocodedAddresses);

                routingStore.RLWaypoints = geocodedAddresses;
                routingStore.RLStartPoint = startPoint;

                // Фильтруем успешные результаты
                const successfulResults = geocodedAddresses.filter(item => item.geocoded);
                const failedResults = geocodedAddresses.filter(item => !item.geocoded);

                console.log("Успешно геокодировано:", successfulResults.length);
                console.log("Не удалось геокодировать:", failedResults.length);

                // Сохраняем результаты
                localStorage.setItem('geocodedAddresses', JSON.stringify(geocodedAddresses));

                // Выводим пример успешного результата
                if (successfulResults.length > 0) {
                  //console.log("Пример координат:", successfulResults[0].coordinates);
                }
              })
              .catch(error => {
                console.error("Ошибка при обработке адресов:", error);
              });

          }
          break;
      }
    }
  })

  //currUser.value = 1 // временно, потом можно заменить на BX.rest.callMethod
  await routingStore.setStorages();
  routingStore.setCycle(true)

  // let addresses = [
  //   {
  //     ID: 1,
  //     name: 'Абыев Малик Гамдулла Оглы (Мельзаводская, 44)',
  //     address: '625001, Тюменская обл, г.о. город Тюмень, г Тюмень, ул Мельзаводская, д. 44',
  //     coordinates: [65.497147, 57.17345]
  //   },
  //   {
  //     ID: 2,
  //     name: 'Сушкова Тамара Геннадьевна( г Тюмень, ул Большая Заречная, д. 32)',
  //     address: '625005, Тюменская область, г Тюмень, ул Большая Заречная, д. 32',
  //     coordinates: [65.519883, 57.173947]
  //   },
  //   {
  //     ID: 3,
  //     name: 'Ломакина Ирина Николаевна (с Княжево, ул Ленина, д. 65)',
  //     address: '625506, Тюменская область, р-н Тюменский, с Княжево, ул Ленина, д. 65',
  //     coordinates: [65.748199, 56.868507]
  //   },
  //   {
  //     ID: 4,
  //     name: 'Протасова Екатерина Александровна (г Тюмень, ул Героев космоса, д. 23, стр. 3)',
  //     address: '625034, Тюменская область, г Тюмень, ул Героев космоса, д. 23, стр. 3',
  //     coordinates: [65.649618, 57.157959]
  //   },
  //   {
  //     ID: 5,
  //     name: 'ТАВРИЯ ООО (с Княжево, ул Берегового, д. 2/1)',
  //     address: '625506, Тюменская область, р-н Тюменский, с Княжево, ул Берегового, д. 2/1',
  //     coordinates: [65.747372, 56.880533]
  //   },
  //   {
  //     ID: 6,
  //     name: 'ТПК ГАЗ ООО (Широтная, д. 104б)',
  //     address: '625051, Тюменская обл, г.о. город Тюмень, г Тюмень, ул Широтная, д. 104б',
  //     coordinates: [65.583591, 57.10944]
  //   },
  //   {
  //     ID: 7,
  //     name: 'Сорина Лада Сергеевна (г Тюмень, ул Тульская, д. 8)',
  //     address: '625023, Тюменская область, г Тюмень, ул Тульская, д. 8',
  //     coordinates: [65.581328, 57.132836]
  //   },
  //   {
  //     ID: 8,
  //     name: 'Наимова Нурия Муродовна (г Тюмень, проезд Шаимский, д.12)',
  //     address: '625031, Тюменская область, г Тюмень, проезд Шаимский, д. 12',
  //     coordinates: [65.5867, 57.181949]
  //   },
  //   {
  //     ID: 9,
  //     name: 'Островский Иван Вячеславович (Минская 7/1)',
  //     address: '625048, Тюменская область, г Тюмень, ул Минская, д. 7, к. 1',
  //     coordinates: [65.585388, 57.150529]
  //   },
  //   {
  //     ID: 10,
  //     name: 'Безрукова Полина Игоревна (г Тюмень, ул Новоселов, д. 105)',
  //     address: '625018, Тюменская область, г Тюмень, ул Новоселов, д. 105',
  //     coordinates: [65.474805, 57.138917]
  //   },
  //   {
  //     ID: 11,
  //     name: 'АГРОФИРМА КРИММ ООО (Парфенова,17)',
  //     address: 'Тюменская обл, Тюмень г, Парфенова ул, дом 17',
  //     coordinates: [65.593608, 57.133822]
  //   },
  //   {
  //     ID: 12,
  //     name: 'Рзаев Самир Ариф Оглы ( г Тюмень, ул Московский тракт, д. 121, стр. 4)',
  //     address: '625049, Тюменская область, г Тюмень, ул Московский тракт, д. 121, стр. 4',
  //     coordinates: [65.498233, 57.133031]
  //   },
  //   {
  //     ID: 13,
  //     name: 'Губин Николай Николаевич (ул Судоремонтная, д. 29, к. 2)',
  //     address: '625015, Тюменская область, г Тюмень, ул Судоремонтная, д. 29, к. 2',
  //     coordinates: [65.637913, 57.179436]
  //   },
  //   {
  //     ID: 14,
  //     name: 'ФЕНИКС ООО (г Тюмень, ул Спорта, д. 91)',
  //     address: '625031, Тюменская область, г Тюмень, ул Спорта, д. 91',
  //     coordinates: [65.587643, 57.188807]
  //   },
  //   {
  //     ID: 15,
  //     name: 'Коробцова Юлия Сергеевна (ул Пермякова, д. 74, к. 4)',
  //     address: '625016, Тюменская область, г Тюмень, ул Пермякова, д. 74, к. 4',
  //     coordinates: [65.566631, 57.111898]
  //   },
  //   {
  //     ID: 16,
  //     name: 'Розовый фламинго ООО (ул Котовского, д. 13)',
  //     address: '625027, Тюменская область, г Тюмень, ул Котовского, д. 13',
  //     coordinates: [65.57221, 57.14362]
  //   },
  //   {
  //     ID: 17,
  //     name: 'АГРОФИРМА КРИММ ООО (Розы Тренини,3)',
  //     address: 'Тюменская обл, Тюмень г, Розы Тренини ул, дом 3',
  //     coordinates: [65.541227, 57.152985]
  //   },
  //   {
  //     ID: 18,
  //     name: 'Тахиров Рашад Муса Оглы (Московский тракт, 87/1)',
  //     address: 'Тюменская обл, Тюмень г, Московский тракт ул, дом № 87/1',
  //     coordinates: [65.497335, 57.129753]
  //   },
  //   {
  //     ID: 19,
  //     name: 'НЕПТУН ООО (г Тюмень, ул Шишкова, д. 84/1)',
  //     address: '625031, Тюменская область, г Тюмень, ул Шишкова, д. 84/1',
  //     coordinates: [65.583888, 57.193669]
  //   },
  //   {
  //     ID: 20,
  //     name: 'Оруджов Тельман Дилян Оглы (Одесская,20)',
  //     address: 'Тюменская обл, Тюмень г, Одесская ул, дом 20',
  //     coordinates: [65.595261, 57.147912]
  //   },
  //   {
  //     ID: 21,
  //     name: 'НИВА ПЛЮС ООО (Мельничная,79)',
  //     address: '625000, Тюменская обл, Тюмень г, Мельничная, 79',
  //     coordinates: [65.553615, 57.139737]
  //   },
  //   {
  //     ID: 22,
  //     name: 'Юрин Владислав Анатольевич (Русское поле снт)',
  //     address: '625526, Тюменская обл, Тюменский р-н, Русское поле снт',
  //     coordinates: [65.577465, 57.22511]
  //   },
  //   {
  //     ID: 23,
  //     name: 'Коробцова Юлия Сергеевна (ул Беляева, д. 29, к. 1)',
  //     address: '625040, Тюменская область, г Тюмень, ул Беляева, д. 29, к. 1',
  //     coordinates: [65.649905, 57.176348]
  //   },
  //   {
  //     ID: 24,
  //     name: 'НЕПТУН ООО (Одесская,22Б)',
  //     address: '625023, Тюменская обл, Тюмень г, Одесская ул, дом 22, корпус б',
  //     coordinates: [65.592584, 57.147277]
  //   },
  //   {
  //     ID: 25,
  //     name: 'АЛЬЯНС ООО (Кремлевская,31)',
  //     address: '625049, Тюменская обл, Тюмень г, Кремлевская ул, дом 31',
  //     coordinates: [65.492619, 57.14089]
  //   },
  //   {
  //     ID: 26,
  //     name: 'ВЕСНА ООО (Судостроителей, 4) ИНН 7203283452',
  //     address: '625034, Тюменская обл, г.о. город Тюмень, г Тюмень, ул Судостроителей, д. 4',
  //     coordinates: [65.628651, 57.156958]
  //   },
  //   {
  //     ID: 27,
  //     name: 'Хахалин Вадим Олегович ( г Тюмень, ул Николая Ростовцева, д. 2/1 )',
  //     address: '625033, Тюменская область, г Тюмень, ул Николая Ростовцева, д. 2, к. 1',
  //     coordinates: [65.575282, 57.10288]
  //   },
  //   {
  //     ID: 28,
  //     name: 'ТПК ГАЗ ООО (30 лет Победы, 31Б)',
  //     address: '625007, Тюменская обл, г Тюмень, ул 30 лет Победы, д. 31, к. Б',
  //     coordinates: [65.569326, 57.12628]
  //   },
  //   {
  //     ID: 29,
  //     name: 'Киселева Светлана Владимировна (г Тюмень, ул Вьюжная, д. 15)',
  //     address: '625063, Тюменская область, г Тюмень, ул Вьюжная, д. 15',
  //     coordinates: [65.503318, 57.11961]
  //   },
  //   {
  //     ID: 30,
  //     name: 'Ревченко Наталия Евгеньевна (г Тюмень, ул Энергетиков, д. 60а)',
  //     address: '625013, Тюменская область, г Тюмень, ул Энергетиков, д. 60а',
  //     coordinates: [65.594991, 57.135043]
  //   },
  //   {
  //     ID: 31,
  //     name: 'Чирко Константин Александрович (Пермякова, 76/3)',
  //     address: '625033, Тюменская обл, Тюмень г, Пермякова ул, дом 76, корпус 3',
  //     coordinates: [65.564862, 57.111121]
  //   },
  //   {
  //     ID: 32,
  //     name: 'Мамедова Наталия Васильевна (г Тюмень, ул Трубная, д. 29)',
  //     address: '625056, Тюменская область, г Тюмень, ул Трубная, д. 29',
  //     coordinates: [65.460414, 57.190007]
  //   },
  //   {
  //     ID: 33,
  //     name: 'Исмаилов Аслан Мехдигулу Оглы( г Тюмень, ул Павла Шарова, д. 7, к. 2)',
  //     address: '625042, Тюменская область, г Тюмень, ул Павла Шарова, д. 7, к. 2',
  //     coordinates: [65.563128, 57.100636]
  //   },
  //   {
  //     ID: 34,
  //     name: 'Бакшеев Александр Евгеньевич (Полевая,105)',
  //     address: '625001, Тюменская обл, Тюмень г, Полевая ул, дом 105',
  //     coordinates: [65.490454, 57.169575]
  //   }
  // ];

  let addresses = [];

  addresses = addresses.map((item, index) => ({
    //ID: index + 1,   // Начинаем нумерацию с 1
    ...item,
    title: item.name,
    price: 0
  }));

  //Использование
  // geocodeAllAddresses(addresses)
  //   .then(geocodedAddresses => {
  //     console.log("Все адреса с координатами:", geocodedAddresses);

  //     //routingStore.RLWaypoints = geocodedAddresses;
  //     //routingStore.RLStartPoint = geocodedAddresses[0];

  //     // Фильтруем успешные результаты
  //     const successfulResults = geocodedAddresses.filter(item => item.geocoded);
  //     const failedResults = geocodedAddresses.filter(item => !item.geocoded);

  //     console.log("Успешно геокодировано:", successfulResults.length);
  //     console.log("Не удалось геокодировать:", failedResults.length);

  //     // Сохраняем результаты
  //     //localStorage.setItem('geocodedAddresses', JSON.stringify(geocodedAddresses));

  //     // Выводим пример успешного результата
  //     if (successfulResults.length > 0) {
  //       console.log("Пример координат:", successfulResults[0].coordinates);
  //     }
  //   })
  //   .catch(error => {
  //     console.error("Ошибка при обработке адресов:", error);
  //   });

  // const location: YMapLocationRequest = {
  //   center: [37.588144, 55.733842],
  //   zoom: 9
  // };

});

</script>

<template>
  <div class="ymap-container-main" style="">
    <div class="ymap-container-map" style="width: 100vw; height: 100vh">
      <MapComponent />
    </div>
    <div class="ymap-container-controll">
      <div class="ymap-container-controll_top">
        <h4>Заполните поля:</h4>
        <InputsPanel :styleClass="'ymap-inputspanel_container'" />
        <h4>Выбранный склад:</h4>
        <StorageSelector />
        <!-- <h4>Выбранный водитель:</h4>
        <DriverSelector /> -->
        <RoadOptions />
      </div>
      <div class="ymap-container-controll_bottom">
        <InfoPanel />
        <ButtonsPanel
          @route-data="handleRouteData"
        />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
